import Quill from "quill"
import { createErrorNotice } from "../util/notices"

const processURL = (quill: Quill, url: string) => {
  if (url) {
    let href = prompt("Enter the URL")
    if (!href.startsWith("http")) {
      href = `https://${href}`
    }
    quill.format("link", href)
  } else {
    quill.format("link", false)
  }
}

const processImage = (quill: Quill, fileInput: HTMLInputElement) => {
  let uploadHandler = () => {
    if (fileInput.files != null && fileInput.files[0] != null) {
      const imageFile = fileInput.files[0]
      const formData = new FormData()

      formData.append("filename", imageFile.name)
      formData.append("type", imageFile.type)
      formData.append("content", imageFile)
      formData.append("_csrf_token", document.querySelector('meta[name="csrf-token"]').getAttribute("content"))

      fetch("/api/attachments", {
        method: "POST",
        body: formData,
        mode: "same-origin",
        credentials: "same-origin",
      })
        .then((response) => {
          if (!response.ok) {
            createErrorNotice("A problem occurred while trying to upload your file. (Only PDF and images are allowed)")
            return Promise.reject()
          } else {
            return response.json()
          }
        })
        .then(({ url }) => {
          if (url) {
            quill.format("image", url)
          }
        })
    }
  }

  fileInput.addEventListener("change", uploadHandler, { once: true })

  fileInput.click()
}

document.addEventListener("DOMContentLoaded", () => {
  let simpleContainer = [["bold", "italic"], [{ list: "ordered" }, { list: "bullet" }], ["link"], ["clean"]]

  let advancedContainer = [
    [{ header: 1 }, { header: 2 }],
    ["bold", "italic", "blockquote"],
    [{ list: "ordered" }, { list: "bullet" }],
    ["link", "image", "video"],
    ["clean"],
  ]

  const holders: NodeListOf<HTMLElement> = document.querySelectorAll(".js-content-editor-holder")
  for (let holder of holders) {
    const isSimple = holder.dataset.simple === "true"
    const editor = holder.querySelector(".js-editor")
    const fileInput: HTMLInputElement = holder.querySelector("input.ql-image[type=file]")
    const hiddenInput: HTMLInputElement = holder.querySelector(".js-hidden-field")

    let quill

    if (editor.classList.contains("js-readonly")) {
      quill = new Quill(editor, {
        theme: "snow",
        modules: { toolbar: false },
        readOnly: true,
      })
    } else {
      quill = new Quill(editor, {
        theme: "snow",
        modules: {
          toolbar: {
            container: isSimple ? simpleContainer : advancedContainer,
            handlers: {
              link: function (url) {
                processURL(this.quill, url)
              },
              image: function () {
                processImage(this.quill, fileInput)
              },
            },
          },
        },
      })
    }

    if (hiddenInput.value != "") {
      quill.setContents(JSON.parse(hiddenInput.value))
    }

    quill.on("editor-change", () => {
      hiddenInput.value = JSON.stringify(quill.getContents())
    })
  }
})
